import * as React from 'react'
import { HorizontalAlignment } from '@thg-commerce/enterprise-core'
import {
  ButtonsContainer,
  Title,
  StyledButton,
  SimpleTitleAndCtaText,
  Subtitle,
} from './styles'

export interface SimpleTitleAndCtaProps {
  className?: string
  title?: string
  subtitle?: string
  text?: string
  textAlign?: HorizontalAlignment
  buttonProps?: {
    CTAUrl: string
    CTAText: string
  }
}

export const SimpleTitleAndCta = (props: SimpleTitleAndCtaProps) => {
  return (
    <div className={props.className}>
      {props.title && (
        <Title
          alignment={props.textAlign || 'center'}
          data-testid="widget-title"
        >
          {props.title}
        </Title>
      )}

      {props.subtitle && (
        <Subtitle
          alignment={props.textAlign || 'center'}
          data-testid="widget-subtitle"
        >
          {props.subtitle}
        </Subtitle>
      )}

      {props.text && (
        <SimpleTitleAndCtaText
          alignment={props.textAlign || 'center'}
          data-testid="widget-text"
        >
          {props.text}
        </SimpleTitleAndCtaText>
      )}
      {props.buttonProps && (
        <ButtonsContainer alignment={props.textAlign || 'center'}>
          <StyledButton
            renderedAs="a"
            href={props.buttonProps.CTAUrl}
            data-testid="widget-button"
          >
            {props.buttonProps.CTAText}
          </StyledButton>
        </ButtonsContainer>
      )}
    </div>
  )
}
